import React, { Component } from 'react'
import {
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core/'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import IndexTable from './Table/IndexTable'
import Alert from '../../../Alert/Alert'
import _ from 'lodash'

import withTranslate from 'react-redux-multilingual/lib/withTranslate'

class IndexPageContent extends Component {
  state = {
    grade: [],
    gradeData: [],
    adjustData: [],
    openDialog: false
  }

  indexCalculate = () => {
    let param = {
      company_id: this.props.filterControls.company_id.value.value,
      form_id: this.props.filterControls.form_id.value.value,
      org_id: this.props.filterControls.org_id.value.value
    }

    this.props.fetchForceRankFilter(param)
    this.handleClose()
  }

  handleClickOpen = () => {
    if (_.isEmpty(this.props.filterData)) {
      let param = {
        company_id: this.props.filterControls.company_id.value.value,
        form_id: this.props.filterControls.form_id.value.value,
        org_id: this.props.filterControls.org_id.value.value
      }
      this.props.fetchForceRankFilter(param)
    } else {
      this.setState({ openDialog: true })
    }
  }

  handleClose = () => {
    this.setState({ openDialog: false })
  }

  render() {
    return (
      <Aux>
        <Alert />
        <Paper
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            backgroundColor: '#DDDDDD',
            padding: '10px',
            marginBottom: '15px'
          }}>
          <Button
            variant='contained'
            style={{
              color: 'white',
              backgroundColor: '#FFCC00 ',
              fontWeight: 'bold'
            }}
            onClick={this.handleClickOpen}>
            {this.props.translate('indexCalculation')}
          </Button>
        </Paper>
        <Dialog
          open={this.state.openDialog}
          onClose={this.handleClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'>
          <DialogTitle id='alert-dialog-title'>
            {this.props.translate('IndexCalculateTab')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {this.props.translate('confirmDeleteData')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={this.indexCalculate}>
              {this.props.translate('confirm')}
            </Button>
            <Button variant='outlined' onClick={this.handleClose} autoFocus>
              {this.props.translate('cancel')}
            </Button>
          </DialogActions>
        </Dialog>
        <IndexTable
          translate={this.translate}
          adjustData={this.props.adjustData}
          gradeData={this.props.gradeData}
          loading={this.props.loading}
          pagination={this.props.pagination}
          filterControls={this.props.filterControls}
          filterData={this.props.filterData}
          fetchForceRankFilter={param => {
            this.props.fetchForceRankFilter(param)
          }}
          fetchAdjust={param => {
            this.props.fetchAdjust(param)
          }}
        />
      </Aux>
    )
  }
}

export default withTranslate(IndexPageContent)
